import { connect } from 'react-redux';
import ViolationDetailTabs from './ViolationDetailTabs';
import { getViolationDetailsBegin, getViolationCommentListBegin } from '../../store/actions/violation.actions';
import {
    getViolationDetail,
    getViolationDetailLoading,
    getViolationEditForm,
    getViolationCommentList,
    getLoadMoreViolationCommentList,
} from '../../store/selectors/violation.selectors';
import { getApplicationDetailBegin, setActiveTab } from '../../store/actions/license.actions';
import { getApplicationPersonDetails } from '../../store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const isLoading = getViolationDetailLoading(state);
    const editForm = getViolationEditForm(state);
    const violationDetail = getViolationDetail(state);
    const violationCommentList = getViolationCommentList(state);
    const personDetail = getApplicationPersonDetails(state);
    const hasMoreViolationComments = getLoadMoreViolationCommentList(state);
    return { isLoading, editForm, violationDetail, violationCommentList, personDetail, hasMoreViolationComments };
};

const mapDispatchToProps = {
    getViolationDetails: getViolationDetailsBegin,
    setActiveTab: setActiveTab,
    getViolationCommentList: getViolationCommentListBegin,
    getApplication: getApplicationDetailBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(ViolationDetailTabs);
